const IMPERIAL_RATIO = 0.89218269;

export const REDUCED_CO2_PLOT_MEASURE_UNIT = ["MT", "ST"];

export const REDUCED_CO2_MEASURE_UNIT = ["ha", "acre"];

export function convertToImperial(value: number): number {
  return Math.round(value * IMPERIAL_RATIO);
}
